<script setup>
const { locale } = useI18n()
const config = useRuntimeConfig()
const websiteConfig = useState('config')
onMounted(() => {
  window.HSStaticMethods.autoInit();
})

</script>


<template>

  <!-- Slider -->
  <div dir="ltr" class="bg-gradient-to-r from-slate-500 to-slate-800">

    <div data-hs-carousel='{
      "loadingClasses": "opacity-0" , "isAutoPlay": true,  "speed":5000
    }' class="relative">
      <div
        class="hs-carousel relative overflow-hidden w-full max-h-full h-[600px] 2xl:h-[600px] xl:h-[500px]  md:h-[400px]">
        <div
          class="hs-carousel-body absolute top-0 bottom-0 start-0 flex flex-nowrap transition-transform duration-700 opacity-0">
          <!-- Item -->
          <div v-for="item in websiteConfig[locale].slideshows" class="hs-carousel-slide">

            <div :style="`
    background: url(${config.public.apiBase}/public/uploads/${item.picture.desktop});background-repeat: no-repeat;background-position-x: center;
    background-size: cover;`"
              class="h-[600px] 2xl:h-[600px] xl:h-[500px]  md:h-[400px] px-10 flex flex-col  bg-cover bg-center bg-no-repeat pt-28">

              <div dir="rtl" class="mx-auto md:my-auto  pb-5 md:ps-10 md:pb-10  w-full max-w-7xl ">

                <span
                  class="block font-black drop-shadow-2xl w-full lg:max-w-sm  text-white text-2xl md:text-3xl lg:text-3xl xl:text-4xl 2xl:text-5xl text-center md:text-start">{{
                    item.title
                  }}</span>
                <span class="block text-white mt-6  w-full md:max-w-md text-center md:text-start text-sm lg:text-md ">{{ item.subtitle }} </span>
                <div v-if="item.url" class="mt-5 ">
                  <a :href="item.url"
                    class="py-2 px-4  inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 ">
                    {{ $t('readMore') }}
                    <svg class="flex-shrink-0 size-4 rtl:rotate-180" xmlns="http://www.w3.org/2000/svg" width="24"
                      height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- End Item -->

        </div>
      </div>


      <div
        class="hs-carousel-pagination flex flex-col items-center justify-center absolute bottom-16 left-8  space-y-2  ">
        <span v-for="item in websiteConfig[locale].slideshows"
          class="hs-carousel-active:bg-blue-700 hs-carousel-active:border-blue-700 size-4 border bg-white  border-gray-400 rounded-full cursor-pointer dark:border-neutral-600 dark:hs-carousel-active:bg-blue-500 dark:hs-carousel-active:border-blue-500">
        </span>
      </div>
    </div>


  </div>
  <!-- End Slider -->




</template>
